import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { warrensburgMOConfig } from "./data";

export default function WarrensburgMOPage() {
  return <CityPageTemplate config={warrensburgMOConfig} />;
}